<template>
    <div class="mt-10 px-4">
        <div class="timeline_top flex flex-row">
            <div class="timeline_intro w-[500px]">
                <h1 class="mx-auto text-6xl font-bold font-serif">Linha do tempo</h1>
                <p class="mt-2 mb-4 text-xl">Uma seleção de eventos, programas e pessoas que marcaram a história da Fapesp. Clique nos círculos para saber mais sobre cada item ou confira nos destaques abaixo</p>
                <div class="timeline_legend flex flex-row mb-10">
                    <div class="flex flex-col text-left">
                        <button id="legend_marcos" @click="categoryHighlight('marcos')"><span class="text-green">⬤</span> Marcos legais e regulatórios</button>
                        <button id="legend_programas" @click="categoryHighlight('programas')"><span class="text-purple">⬤</span> Programas</button>
                    </div>
                    <div class="flex flex-col">
                        <button id="legend_pessoas" @click="categoryHighlight('pessoas')"><span class="text-red">⬤</span> Presidentes e diretores</button>
                        <button id="legend_fatos" @click="categoryHighlight('fatos')"><span class="text-orange">⬤</span> Fatos históricos</button>
                    </div>
                </div>
            </div>
            <div v-if="nodeSelected" class="timeline_box absolute xl:relative bg-offwhite w-11/12 xl:w-fit p-4 xl:p-0 xl:m-0 mb-2 xl:pt-4 xl:top-0 top-1/2 xl:ml-4 mx-auto my-auto border border-black xl:border-0 z-50">
                <div class="flex flex-col xl:flex-row">
                    <div class="my-2">
                        <button class="float-right font-semibold xl:hidden block" @click="nodeSelected = !nodeSelected">[Fechar]</button>
                    </div>
                    <div v-if="nodeToDisplay.imagem" class="w-full xl:w-[250px] h-auto mr-2">
                        <img :src="`${publicPath}static/linha-do-tempo/img/${nodeToDisplay.imagem}`" />
                    </div>
                    <div class="pr-2 w-full xl:w-[500px]">
                        <p class="text-lg font-bold mb-2">{{ nodeToDisplay.ano }}</p>
                        <p class="timeline_text h-[300px] xl:h-[150px] overflow-y-scroll pr-2" v-html="nodeToDisplay.texto"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="timeline_bottom_wrapper w-full 1080p:cursor-auto cursor-grab 1080p:overflow-x-hidden overflow-x-scroll">
            <div class="timeline_bottom w-[1880px]">
                <div id="timeline_graph_outer" class="timeline_graph relative cursor-pointer">
                    <div id="wrapper" class="">
                        <div id="timeline_tooltip" class="absolute bg-offwhite p-1"></div>
                    </div>
                </div>
                <div class="timeline_scale flex flex-row justify-between">
                    <div class="relative" v-for="(item, index) in timelineScale" :key="index">
                        <img v-if="index + 1 == timelineScale.length" :src="require(`@/assets/img/linha-do-tempo/linha-tempo-marcador-2020.svg`)" />
                        <img v-else :src="require(`@/assets/img/linha-do-tempo/linha-tempo-marcador.svg`)" />
                        <p class="text-center">{{ item }}</p>
                        <ul v-if="dataLoaded">
                            <li v-for="(entry, i) in filteredLists(index)" :key="i">
                                <button
                                    @mouseover="highlightNode(filteredLists(index)[i].idx, filteredLists(index)[i].cat)"
                                    @mouseleave="removeHighlightNode(filteredLists(index)[i].idx, filteredLists(index)[i].cat)"
                                    @click="displayNode(filteredLists(index)[i].idx)"
                                >
                                    {{ filteredLists(index)[i].keyword }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3'

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            timelineScale: ['1960 — 1969', '1970 — 1979', '1980 — 1989', '1990 — 1999', '2000 — 2009', '2010 — 2020'],
            timelineArray: null,
            dataLoaded: false,
            nodeSelected: false,
            nodeToDisplay: null,
            selectedCategory: null,
        }
    },
    mounted() {
        this.getTimelineData()
    },
    computed: {},
    methods: {
        categoryHighlight: function (category) {
            if (category == this.selectedCategory) {
                d3.selectAll('.timeline_node_pessoas').attr('class', `timeline_node timeline_node_pessoas`)
                d3.selectAll('.timeline_node_marcos').attr('class', `timeline_node timeline_node_marcos`)
                d3.selectAll('.timeline_node_fatos').attr('class', `timeline_node timeline_node_fatos`)
                d3.selectAll('.timeline_node_programas').attr('class', `timeline_node timeline_node_programas`)

                d3.select('#legend_pessoas').attr('class', '')
                d3.select('#legend_marcos').attr('class', '')
                d3.select('#legend_fatos').attr('class', '')
                d3.select('#legend_programas').attr('class', '')

                this.selectedCategory = null
                console.log('igual')
            } else {
                let cat = ['pessoas', 'marcos', 'fatos', 'programas']
                let cat_filtered = cat.filter((e) => e != category)

                //Node
                d3.selectAll('.timeline_node_' + cat_filtered[0]).attr('class', `timeline_node timeline_node_${cat_filtered[0]} timeline_node_disabled`)
                d3.selectAll('.timeline_node_' + cat_filtered[1]).attr('class', `timeline_node timeline_node_${cat_filtered[1]} timeline_node_disabled`)
                d3.selectAll('.timeline_node_' + cat_filtered[2]).attr('class', `timeline_node timeline_node_${cat_filtered[2]} timeline_node_disabled`)
                d3.selectAll('.timeline_node_' + category).attr('class', `timeline_node timeline_node_${category}`)

                //Legend
                d3.select(`#legend_${cat_filtered[0]}`).attr('class', 'timeline_legend_disabled')
                d3.select(`#legend_${cat_filtered[1]}`).attr('class', 'timeline_legend_disabled')
                d3.select(`#legend_${cat_filtered[2]}`).attr('class', 'timeline_legend_disabled')
                d3.select(`#legend_${category}`).attr('class', '')

                this.selectedCategory = category
            }
        },
        displayNode: function (id) {
            let timelineArray = this.timelineArray
            const selected = timelineArray.filter((v) => v.idx === id)

            this.nodeToDisplay = selected[0]

            this.nodeSelected = true
        },
        highlightNode: function (id, cat) {
            let node = document.getElementById('node_' + id)
            node.classList.remove('timeline_node')
            node.classList.remove('timeline_node_' + cat)

            node.classList.add('timeline_node_selected')
            node.classList.add('selected_' + cat)
        },
        removeHighlightNode: function (id, cat) {
            let node = document.getElementById('node_' + id)
            node.classList.add('timeline_node')
            node.classList.add('timeline_node_' + cat)

            node.classList.remove('timeline_node_selected')
            node.classList.remove('selected_' + cat)
        },
        filteredLists: function (index) {
            let dateEndArray = []
            let timelineScaleArray = this.timelineScale
            let timelineArray = this.timelineArray
            for (let i in timelineScaleArray) {
                let dateEnd = timelineScaleArray[i].substring(timelineScaleArray[i].length - 4)
                dateEndArray.push(parseInt(dateEnd))
            }
            let dateCap = dateEndArray[index]

            const filteredEntries = timelineArray.filter((v) => parseInt(v.ano) <= dateCap && parseInt(v.ano) > dateCap - 10 && v.destaque === 'destaque')

            return filteredEntries
        },
        getTimelineData: function () {
            d3.csv(this.publicPath + 'static/linha-do-tempo/data/linha-tempo.csv', (data) => {
                return data
            }).then((data) => {
                this.timelineArray = data
                this.dataLoaded = true
                this.startTimeline()
            })
        },
        startTimeline: function () {
            const outer_wrapper = document.getElementById('timeline_graph_outer').getBoundingClientRect()
            const colors = {
                lightGray: 'rgba(192, 188, 183, 0.5)',
                gray: 'rgba(192, 188, 183, 1)',
            }
            const data = this.timelineArray
            let dimensions = {
                width: outer_wrapper.width,
                height: 300,
                margins: {
                    top: 0,
                    right: 0,
                    bottom: 30,
                    left: 0,
                },
            }
            dimensions.boundedWidth = dimensions.width - dimensions.margins.left - dimensions.margins.right
            dimensions.boundedHeight = dimensions.height - dimensions.margins.top - dimensions.margins.bottom

            const wrapper = d3.select('#wrapper').append('svg').attr('width', dimensions.width).attr('height', dimensions.height)

            const bounds = wrapper.append('g').style('transform', `translate(${dimensions.margins.left}px, ${dimensions.margins.top}px)`)

            //Grid
            const scaleDivs = 72
            const scaleExceptions = [0, 11, 12, 23, 24, 35, 36, 47, 48, 59, 60, 72]
            const grid = wrapper.append('g')
            console.log(dimensions.width)
            for (let i = 0; i < scaleDivs + 1; i++) {
                let x = ((dimensions.width - 1) / scaleDivs) * i
                if (!scaleExceptions.includes(i)) {
                    grid.append('line').attr('class', 'grid_line').attr('x1', x).attr('y1', 0).attr('x2', x).attr('y2', dimensions.boundedHeight).attr('stroke', colors.lightGray)
                }
            }

            //Nodes
            bounds
                .append('g')

                .selectAll('g')
                .data(data)
                .enter()
                .append('g')
                .attr('class', (d) => {
                    let cat = d.cat
                    return 'timeline_node timeline_node_' + cat
                })
                .attr('id', (d) => {
                    let id = d.idx
                    return 'node_' + id
                })
                .append('circle')
                .attr('cx', (d) => {
                    let x = getX(d.ano)
                    return x
                })
                .attr('cy', (d) => {
                    let y = d.eixoY * 30
                    return y
                })
                .attr('r', 12)
                .attr('fill', 'none')
                .attr('stroke', colors.gray)
                .attr('class', 'timeline_node_outer_circle')

            d3.selectAll('.timeline_node')
                .on('mouseenter', onMouseEnter)
                .on('mousemove', onMouseEnter)
                .on('mouseleave', onMouseLeave)
                .on('click', (d, e) => {
                    // console.log(e.idx)
                    this.displayNode(e.idx)
                })
                .append('circle')
                .attr('class', 'timeline_node_inner_circle')
                .attr('cx', (d) => {
                    let x = getX(d.ano)
                    return x
                })
                .attr('cy', (d) => {
                    let y = d.eixoY * 30
                    return y
                })
                .attr('r', 5)
                .attr('fill', colors.gray)

            function onMouseEnter(d, e) {
                d3.select('#timeline_tooltip').style('left', d.layerX + 10 + 'px')
                d3.select('#timeline_tooltip').style('top', d.layerY + 10 + 'px')
                d3.select('#timeline_tooltip').style('visibility', 'visible')
                d3.select('#timeline_tooltip').text(e.keyword)

                d3.select(this).attr('class', `timeline_node_selected selected_${e.cat}`)
            }
            function onMouseLeave(d, e) {
                d3.select('#timeline_tooltip').style('visibility', 'hidden')
                d3.select(this).attr('class', `timeline_node`)
                d3.select(this).attr('class', (e) => {
                    let cat = e.cat
                    return 'timeline_node timeline_node_' + cat
                })
            }

            function getX(xData) {
                let year = parseInt(xData)
                let index = year - 1960
                let offset
                if (index >= 50) {
                    offset = 11
                } else if (index >= 40) {
                    offset = 9
                } else if (index >= 30) {
                    offset = 7
                } else if (index >= 21) {
                    offset = 5
                } else if (index >= 10) {
                    offset = 3
                } else {
                    offset = 1
                }

                let x = ((dimensions.width - 1) / scaleDivs) * (index + offset)
                return x
            }
        },
    },
}
</script>

<style lang="postcss" scoped>
svg {
    cursor: pointer;
}
circle {
    cursor: pointer;
}
.grid_line {
    pointer-events: none;
}
.timeline_text,
.timeline_bottom_wrapper {
    scrollbar-color: theme(colors.gray) theme(colors.warm-gray);
    scrollbar-width: thin;
}
.timeline_legend button {
    @apply text-left mb-2 mr-4;
}
.timeline_legend_disabled {
    opacity: 0.3 !important;
}
.timeline_node_disabled {
    cursor: auto !important;
    pointer-events: none !important;
    fill: theme(colors.gray) !important;
    stroke: theme(colors.gray) !important;
    opacity: 0.3 !important;
}
#timeline_tooltip {
    visibility: hidden;
}
.timeline_node {
    cursor: pointer;
    fill: theme(colors.gray);
    stroke: theme(colors.gray);
    z-index: 2;
    opacity: 1;
}
.timeline_node_selected {
    cursor: pointer;
}

.timeline_node .timeline_node_inner_circle {
    fill: inherit;
    stroke: inherit;
}
.timeline_node .timeline_node_outer_circle {
    fill: none;
    stroke: inherit;
}
.selected_programas {
    fill: theme(colors.purple);
    stroke: theme(colors.purple);
}
.selected_pessoas {
    fill: theme(colors.red);
    stroke: theme(colors.red);
}
.selected_marcos {
    fill: theme(colors.green);
    stroke: theme(colors.green);
}
.selected_fatos {
    fill: theme(colors.orange);
    stroke: theme(colors.orange);
}
.timeline_node_selected .timeline_node_inner_circle {
    fill: theme(colors.offwhite);
    stroke: inherit;
}
.timeline_node_selected .timeline_node_outer_circle {
    fill: inherit;
    stroke: inherit;
}
</style>
